// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2s6t5","signatureBlock":"Footer_signatureBlock__2Q0R9","signature":"Footer_signature__22fW9"};